import React from "react";
import Layout from "../../../components/layout";
import SEO from "../../../components/seo";
import styles from "./index.module.scss";
import { CardBox } from "../../../components/cardbox";
import Input from "../../../components/Input";

class InflationCalculator extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      inputValue: 1000,
      inflationRate: 3,
      futureYear: new Date().getFullYear() + 5
    };
  }

  changeInputValue = e => this.setState({ inputValue: e.target.value });

  changeInflationRate = e => this.setState({ inflationRate: e.target.value });

  changeFutureYear = e => this.setState({ futureYear: e.target.value });

  format = val => Math.round(val * 100) / 100;

  computeFutureValue = () => {
    const { inputValue, inflationRate, futureYear } = this.state;
    const yearNow = new Date().getFullYear();
    const percentualDecrease = 1 - inflationRate / 100;

    return this.format(
      inputValue * percentualDecrease ** (futureYear - yearNow)
    );
  };

  howMuchYouShouldHave = () => {
    const { inputValue, inflationRate, futureYear } = this.state;
    const yearNow = new Date().getFullYear();
    const percentualIncrease = 1 + inflationRate / 100;

    return this.format(
      inputValue * percentualIncrease ** (futureYear - yearNow)
    );
  };

  getErrorMessage = () => {
    const { inputValue, inflationRate, futureYear } = this.state;
    const yearNow = new Date().getFullYear();
    if (futureYear <= yearNow) {
      return `Write down future year, (more than ${yearNow})`;
    }
    if (!inputValue) {
      return "Fill in input value";
    }
    if (inflationRate === "") {
      return "Fill in inflation rate, for example 2% (Average is 1-2 %)";
    }
    if (inflationRate < 0) {
      return "Inflation rate must be more than 0%";
    }
    return null;
  };

  render() {
    const { inputValue, inflationRate, futureYear } = this.state;
    const yearNow = new Date().getFullYear();
    const errorMessage = this.getErrorMessage();
    return (
      <Layout>
        <SEO
          title="Inflation money calculator"
          description="This calculator computes how much your money will be worth in the future."
          keywords={["inflation", "money", "calculator", "investing"]}
        />
        <CardBox>
          <div>
            <div className="topbottom_margined">
              Inflation is the yearly rate of decreasing monetary values. To see
              average inflation rates over the years, take a look at this{" "}
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.usinflationcalculator.com/inflation/historical-inflation-rates"
              >
                page
              </a>
            </div>
            <div className={styles.input_panel}>
              <div className={styles.input_div}>
                <span>{`Value in ${yearNow}:`}</span>
                <div>
                  <Input value={inputValue} onChange={this.changeInputValue} />
                </div>
              </div>

              <div className={styles.input_div}>
                <span>Inflation Rate</span>
                <div>
                  <Input
                    value={inflationRate}
                    onChange={this.changeInflationRate}
                  />
                  %
                </div>
              </div>

              <div className={styles.input_div}>
                <span>Future year</span>
                <div>
                  <Input
                    value={futureYear}
                    onChange={this.changeFutureYear}
                    placeholder="2020"
                  />
                </div>
              </div>
            </div>
            <div className={styles.resultPanel}>
              {errorMessage ? (
                <div className="error">{errorMessage}</div>
              ) : (
                <div>
                  <div style={{ marginBottom: 15 }}>
                    {`Your €${inputValue} will be worth `}
                    <b>€{this.computeFutureValue()}</b>
                    {` in ${futureYear}`}
                  </div>
                  <div>
                    You should have <b>€{this.howMuchYouShouldHave()}</b> to be
                    worth €{inputValue} as of today
                  </div>
                </div>
              )}
            </div>
          </div>
        </CardBox>
      </Layout>
    );
  }
}

export default InflationCalculator;
